import { createApp } from 'vue'
import App from './App.vue'
import AppMobile from './mobile.vue'
import '@/utils/monitor'
import '@/assets/reset.css'

if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
  createApp(AppMobile).mount('#app')
} else {
  createApp(App).mount('#app')
}


